/*
 * Shared website section styles (the prototype's .vStudio block), in the
 * telify layer. Pieces compose these classes; each element still carries its
 * piece's data-part name for custom sites.
 */
@layer telify {
  .wrap {
    width: min(var(--wrap), calc(100% - 80px));
    margin: 0 auto;
  }

  .ic {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  /* Use with .ic. */
  .icSm {
    width: 15px;
    height: 15px;
  }

  .eyebrow {
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--text-tertiary);
  }

  .eyebrow::before {
    content: '';
    width: 28px;
    height: 1px;
    background: var(--accent);
  }

  .h2 {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 56px;
    letter-spacing: -0.018em;
    line-height: 1.02;
  }

  .h3 {
    font-family: var(--font-display);
    font-weight: 500;
    letter-spacing: -0.01em;
    line-height: 1.1;
  }

  .prose p {
    font-size: 18px;
    line-height: 1.8;
    color: var(--text-secondary);
    max-width: 58ch;
  }

  .prose p + p {
    margin-top: 20px;
  }

  .btn {
    appearance: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 54px;
    padding: 0 28px;
    border-radius: var(--r-ctl);
    font-size: 16px;
    font-weight: 600;
    border: 1px solid transparent;
    transition:
      background 0.15s ease,
      border-color 0.15s ease;
    white-space: nowrap;
  }

  /* .btnPrimary and .btnOutline are used with .btn. */
  .btnPrimary {
    background: var(--accent);
    color: var(--text-on-accent);
  }

  .btnOutline {
    background: transparent;
    color: var(--text-primary);
    border-color: var(--field-line);
  }

  .go {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: var(--accent);
    white-space: nowrap;
  }

  .go .ic {
    transition: transform 0.18s ease;
  }

  .go u {
    text-decoration: underline;
    text-decoration-color: rgba(var(--accent-rgb), 0.4);
    text-underline-offset: 4px;
  }

  .sec {
    padding-top: var(--sec);
  }

  .secHead {
    display: grid;
    grid-template-columns: 7fr 5fr;
    gap: 48px;
    align-items: end;
    padding-bottom: 44px;
  }

  .secHead .h2 {
    margin-top: 20px;
  }

  .secIntro {
    font-size: 17px;
    line-height: 1.65;
    color: var(--text-secondary);
    max-width: 42ch;
    justify-self: end;
  }

  @media (hover: hover) {
    .btnPrimary:hover {
      background: var(--accent-hot);
    }

    .btnOutline:hover {
      border-color: var(--text-tertiary);
    }

    .go:hover .ic {
      transform: translateX(3px);
    }
  }

  @media (max-width: 1023px) {
    .wrap {
      width: calc(100% - 32px);
    }

    .h2 {
      font-size: 40px;
    }

    .secHead {
      grid-template-columns: 1fr;
    }

    .secIntro {
      justify-self: start;
    }
  }

  /* Placed (D4): a placed piece's heading, heading columns and intro at the width its placeholder gives it. */
  @container telify-piece (max-width: 1023px) {
    .h2 {
      font-size: 40px;
    }

    .secHead {
      grid-template-columns: 1fr;
    }

    .secIntro {
      justify-self: start;
    }
  }
}
